// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__YbAUl","name":"Header_name__rlvg0","birthday":"Header_birthday__2gHxc","skeleton":"Header_skeleton__Xd08O"};